import { render } from "./botoes.vue?vue&type=template&id=edfdcedc"
import script from "./botoes.vue?vue&type=script&lang=js"
export * from "./botoes.vue?vue&type=script&lang=js"

import "./botoes.vue?vue&type=style&index=0&id=edfdcedc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__